<template>
  <div id="app">
    <side-nav />
    <transition name="fade">
      <router-view style="margin: 10px;"/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';

export default {
  name: 'App',
  components: { SideNav },
  methods: {
    ...mapActions(['fetchCompanies', 'fetchAnalysts']),
  },
  watch: {
    '$auth.user': function (user) {
      setTimeout(() => {
        if (this.$route.path === '/login') { return; }
        if (this.$auth.hasRoles('lockdown')) { return; }
        if (!(
          this.$store.state.app.companies.length &&
          this.$store.state.app.analysts.length)) {
          this.fetchCompanies();
          this.fetchAnalysts();
        }
      }, 200);
    },
  },
};
</script>

<style lang="scss">
// Global (non-scoped) styles for app
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://use.fontawesome.com/releases/v5.11.2/css/all.css');
@import '../node_modules/materialize-css/dist/css/materialize.min.css';
@import '@/main.scss';

#app {
  font-family: 'Avenir', 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $tmf-black;
  padding-left: 220px;
}

div.drag-target {
  display: none;
  background-color: $tmf-gains;
}

a.sidenav-trigger {
  display: none;
  position: fixed;
  top: 50px;
  left: 50px;
  font-size: 2rem;
  color: $tmf-black;
  background-color: #cfd8dc;
  padding: 5px 14px;
  border-radius: 50%;
}

@media only screen and (max-width : 992px) {
  #app {
    padding-left: 0;
  }
  div.drag-target {
    display: block;
  }
  a.sidenav-trigger {}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.0s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
